import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react'

export const CustCotList = ({ custId, cotId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!custId && !cotId) return;
    if (custId) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('custId', custId));
    } else {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('cotId', cotId));
    }
  }, [custId, cotId]);

  return (
    <EntityList entity="CUST_COT" augRowsReq={augRowsReq} />
  )
}
